define('Inspiredspaces.ei1.Main.View', [
    'SCView',
    'inspiredspaces_main.tpl',
    'Inspiredspaces.ei1.Main.Model'
], function (
    SCViewComponent,
    Inspiredspaces_main_tpl,
    InspiredSpacesModel
) {
    'use strict';

    var SCView = SCViewComponent.SCView;
    var self = null;

    var IMAGE_BASE_URL = 'https://1homeoffice.com/';

    // ── Helpers ────────────────────────────────────────────────────────────

    function buildImageUrl(thumbnailPath) {
        if (!thumbnailPath) return '';
        if (thumbnailPath.indexOf('http') === 0) return thumbnailPath;
        return IMAGE_BASE_URL + thumbnailPath;
    }

    /* Name → URL slug map */
    var SLUG_MAP = {
        'inner courtyard': 'innercourtyard',
        'long courtyard': 'longcourtyard',
        'trenza marmi room': 'trenza',
        'courtyard room': 'courtyard',
        'the courtyard room': 'courtyard',
        'carrara room': 'carrara',
        'boston stone room': 'boston',
        'workstation': 'workstation',
        'workstations': 'workstation',
        'alcoves': 'alcoves',
        'serpentine alcove': 'serpentine',
        'travertine alcove': 'travertine',
        'pietra alcove': 'pietra',
        'palladio alcove': 'palladio',
        'foyer alcove': 'foyer'
    };

    function buildRoomUrl(name) {
        var key = (name || '').toLowerCase().trim();
        var slug = SLUG_MAP[key];
        return slug ? '/room/' + slug : '#';
    }

    /* Lower sequenceNumber = higher priority. Missing/invalid values sort last. */
    function getSequence(item) {
        var n = parseInt(item && item.sequenceNumber, 10);
        return isNaN(n) ? Number.MAX_SAFE_INTEGER : n;
    }

    function sortBySequence(list) {
        if (!list || !list.length) return list || [];
        return list.slice().sort(function (a, b) {
            return getSequence(a) - getSequence(b);
        });
    }

    /* Only image + name needed now — no description, capacity, or button */
    function processChild(child) {
        return {
            name: child.name || '',
            imageUrl: buildImageUrl(child.thumbnail || ''),
            roomUrl: buildRoomUrl(child.name),
            description: child.description || ''   // ← add this
        };
    }
    /**
     * Splits a name into two-tone title parts.
     * "Event Venue Spaces"  → accent:"Event Venue"  plain:"Spaces"
     * "Coworking Spaces"    → accent:"Coworking"    plain:"Spaces"
     */
    function splitTitle(name) {
        var parts = (name || '').trim().split(/\s+/);
        if (parts.length < 2) return { accent: name, plain: '' };
        return {
            accent: parts.slice(0, parts.length - 1).join(' '),
            plain: parts[parts.length - 1]
        };
    }

    // ── Main processor ─────────────────────────────────────────────────────

    function processSubCategories(rawSubCategories) {
        if (!rawSubCategories || !rawSubCategories.length) return [];

        var sortedSubCategories = sortBySequence(rawSubCategories);

        var result = [];

        for (var i = 0; i < sortedSubCategories.length; i++) {
            var subCat = sortedSubCategories[i];
            var rawChildren = sortBySequence(subCat.subCategories || []);
            var titleParts = splitTitle(subCat.name);
            var isCoworking = subCat.name.toLowerCase().indexOf('coworking') !== -1;

            if (!isCoworking) {
                // ── Event Venue Spaces ─────────────────────────────────────
                var eventChildren = [];
                for (var j = 0; j < rawChildren.length; j++) {
                    eventChildren.push(processChild(rawChildren[j]));
                }
                result.push({
                    name: subCat.name || '',
                    titleAccent: titleParts.accent,
                    titlePlain: titleParts.plain,
                    description: subCat.description || '',
                    isFirstLayout: true,
                    children: eventChildren,
                    tabs: []
                });

            } else {
                // ── Coworking Spaces ───────────────────────────────────────
                // rawChildren = [ MeetingRoom, Workspace ]
                // Workspace contains: Workstations, Alcoves
                // Alcoves contains:   Serpentine, Travertine, Pietra  (level 5 — now fetched)

                var tabs = [];


                for (var j = 0; j < rawChildren.length; j++) {
                    var child = rawChildren[j];
                    var childName = (child.name || '').toLowerCase().trim();

                    if (childName.indexOf('meeting') !== -1) {
                        // Tab 1: Meeting Room — its subCategories are the individual rooms
                        var meetingChildren = [];
                        var rooms = sortBySequence(child.subCategories || []);
                        for (var k = 0; k < rooms.length; k++) {
                            meetingChildren.push(processChild(rooms[k]));
                        }
                        tabs.push({
                            tabId: 'meeting-room',
                            label: child.name,
                            isDefault: true,
                            children: meetingChildren
                        });

                    } else if (childName.indexOf('workspace') !== -1 ||
                        childName.indexOf('work space') !== -1) {
                        // Workspace → drill into its children for Alcoves
                        var workspaceChildren = sortBySequence(child.subCategories || []);
                        for (var k = 0; k < workspaceChildren.length; k++) {
                            var ws = workspaceChildren[k];
                            var wsName = (ws.name || '').toLowerCase().trim();

                            if (wsName.indexOf('alcove') !== -1) {
                                // Tab 2: Alcoves — its subCategories are Serpentine, Travertine, Pietra
                                var alcoveChildren = [];
                                var alcoveItems = sortBySequence(ws.subCategories || []);
                                for (var m = 0; m < alcoveItems.length; m++) {
                                    alcoveChildren.push(processChild(alcoveItems[m]));
                                }
                                tabs.push({
                                    tabId: 'alcoves',
                                    label: ws.name,
                                    isDefault: false,
                                    children: alcoveChildren
                                });
                            }
                            // Workstation branch removed — Workstation section is now a
                            // standalone hardcoded block, no longer sourced from NetSuite.
                        }
                    }
                }

                result.push({
                    name: subCat.name || '',
                    titleAccent: titleParts.accent,
                    titlePlain: titleParts.plain,
                    description: subCat.description || '',
                    isFirstLayout: false,
                    children: [],
                    tabs: tabs
                });
            }
        }

        return result;
    }

    // ── View ──────────────────────────────────────────────────────────────

    function InspiredSpacesMainView(options) {
        console.log('Initializing InspiredSpacesMainView with options:', options);
        SCView.call(this);
        self = this;
        self.options = options || {};
        self.template = Inspiredspaces_main_tpl;

        self.model = new InspiredSpacesModel();
        self.model.fetch().done(function () {
            self.render();
        });
    }

    InspiredSpacesMainView.prototype = Object.create(SCView.prototype);
    InspiredSpacesMainView.prototype.constructor = InspiredSpacesMainView;

    InspiredSpacesMainView.prototype.getContext = function () {
        var response = self.model.toJSON();
        var categories = (response && response.data) ? response.data : [];
        var mainCategory = (categories && categories.length) ? categories[0] : {};
        var rawSubCategories = mainCategory.subCategories || [];

        console.log('View getContext — rawSubCategories:', rawSubCategories);

        var subCategories = processSubCategories(rawSubCategories);
        var workspaceDescription = '';
        rawSubCategories.forEach(function (category) {

            if ((category.name || '').toLowerCase() === 'coworking spaces') {

                (category.subCategories || []).forEach(function (child) {

                    if ((child.name || '').toLowerCase() === 'workspace') {
                        workspaceDescription = child.description || '';
                    }

                });
            }

        });

        console.log('View getContext — processed subCategories:', subCategories);

        return {
            subCategories: subCategories,
            workspaceDescription: workspaceDescription,
            message: (response && response.message) ? response.message : ''
        };
    };

    return InspiredSpacesMainView;
});
